// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"b5fc46c9","82":"f12257cb","293":"d63d3d14","588":"8db15ecb"}[chunkId] + ".chunk.js";
};